import React from 'react';
import { useHistory } from 'react-router';
import { makeStyles, Theme } from '@material-ui/core';
import { faBrowser, faFileSearch, faComments, faUsersCog } from '@fortawesome/pro-regular-svg-icons';

import { Page } from '../../components/Page';
import { Menu, MenuItem } from '../../components/Menu';
import { PageBody } from '../../components/PageBody';
import { DesktopAppBar } from '../../components/DesktopAppBar';
import { BackAppBar } from '../../components/BackAppBar';

type HomePageProps = {};

HomePage.defaultProps = {};

const useStyles = makeStyles((theme: Theme) => ({}));

function HomePage(props: HomePageProps): React.ReactElement {
    const classes = useStyles();
    const history = useHistory();

    return (
        <Page>
            <BackAppBar title="主選單" />
            <PageBody maxWidth="lg">
                <Menu>
                    <MenuItem
                        icon={faBrowser}
                        text="線上報修"
                        description="填寫資料進行報修或詢價"
                        onClick={() => history.push('/repair')}
                    />
                    <MenuItem
                        icon={faFileSearch}
                        text="報修查詢"
                        description="查詢目前送修中產品的進度"
                        onClick={() => history.push('/repair/search')}
                    />
                    <MenuItem
                        icon={faUsersCog}
                        text="會員服務"
                        description="產品列表查詢、提醒設定及其他專屬服務"
                        onClick={() => history.push('/memberService/action')}
                    />
                </Menu>
            </PageBody>
        </Page>
    );
}

export { HomePage };
